// (function () {
//   'use strict';

//   function getInitial(name) {
//     if (!name) return 'C';

//     return name
//       .trim()
//       .charAt(0)
//       .toUpperCase();
//   }


//   function cleanText(value) {
//     return (value || '')
//       .replace(/\s+/g, ' ')
//       .trim();
//   }


//   function getRating(review) {
//     var ratingNode =
//       review.querySelector('[data-score]') ||
//       review.querySelector('.jdgm-rev__rating');

//     if (!ratingNode) {
//       return 5;
//     }

//     var score =
//       ratingNode.getAttribute('data-score');

//     if (score) {
//       return Number(score) || 5;
//     }

//     var label =
//       ratingNode.getAttribute('aria-label') ||
//       '';

//     var match =
//       label.match(/([0-5](?:\.\d+)?)/);

//     return match
//       ? Number(match[1])
//       : 5;
//   }


//   function makeStars(rating) {
//     rating = Math.round(
//       Math.max(
//         0,
//         Math.min(5, Number(rating) || 0)
//       )
//     );

//     var output = '';

//     for (var i = 1; i <= 5; i++) {
//       output += i <= rating ? '★' : '☆';
//     }

//     return output;
//   }


//   function extractReview(reviewNode) {
//     if (!reviewNode) return null;


//     var nameNode =
//       reviewNode.querySelector('.jdgm-rev__author') ||
//       reviewNode.querySelector('.jdgm-reviewer-name') ||
//       reviewNode.querySelector('[data-reviewer-name]');


//     var titleNode =
//       reviewNode.querySelector('.jdgm-rev__title') ||
//       reviewNode.querySelector('[data-review-title]');


//     var bodyNode =
//       reviewNode.querySelector('.jdgm-rev__body') ||
//       reviewNode.querySelector('.jdgm-text') ||
//       reviewNode.querySelector('[data-review-body]');


//     var verifiedNode =
//       reviewNode.querySelector('.jdgm-rev__buyer-badge') ||
//       reviewNode.querySelector('.jdgm-verified-badge') ||
//       reviewNode.querySelector('[data-verified]');


//     var name = nameNode
//       ? cleanText(nameNode.textContent)
//       : 'Customer';


//     var title = titleNode
//       ? cleanText(titleNode.textContent)
//       : '';


//     var body = bodyNode
//       ? cleanText(bodyNode.textContent)
//       : '';


//     if (!body) {
//       return null;
//     }


//     return {
//       name: name,
//       title: title,
//       body: body,
//       rating: getRating(reviewNode),
//       verified: !!verifiedNode
//     };
//   }


//   function renderCustomReview(wrapper, review) {
//     if (!wrapper || !review) return false;


//     var content =
//       wrapper.querySelector(
//         '[data-mw-review-content]'
//       );

//     var loading =
//       wrapper.querySelector(
//         '.mw-judgeme-featured-review__loading'
//       );

//     var name =
//       wrapper.querySelector(
//         '[data-mw-review-name]'
//       );

//     var initial =
//       wrapper.querySelector(
//         '[data-mw-review-initial]'
//       );

//     var stars =
//       wrapper.querySelector(
//         '[data-mw-review-stars]'
//       );

//     var title =
//       wrapper.querySelector(
//         '[data-mw-review-title]'
//       );

//     var text =
//       wrapper.querySelector(
//         '[data-mw-review-text]'
//       );

//     var verified =
//       wrapper.querySelector(
//         '[data-mw-review-verified]'
//       );


//     if (name) {
//       name.textContent =
//         review.name;
//     }


//     if (initial) {
//       initial.textContent =
//         getInitial(review.name);
//     }


//     if (stars) {
//       stars.textContent =
//         makeStars(review.rating);

//       stars.setAttribute(
//         'aria-label',
//         review.rating +
//           ' out of 5 stars'
//       );
//     }


//     if (title) {
//       if (review.title) {
//         title.textContent =
//           review.title;

//         title.hidden = false;
//       } else {
//         title.hidden = true;
//       }
//     }


//     if (text) {
//       text.textContent =
//         review.body;
//     }


//     if (verified) {
//       verified.hidden =
//         !review.verified;
//     }


//     if (loading) {
//       loading.style.display =
//         'none';
//     }


//     if (content) {
//       content.hidden = false;
//     }


//     wrapper.classList.add(
//       'is-loaded'
//     );

//     return true;
//   }


//   function findRenderedReview() {
//     var source =
//       document.querySelector(
//         '.mw-judgeme-source'
//       );

//     if (!source) {
//       return null;
//     }


//     var review =
//       source.querySelector(
//         '.jdgm-rev'
//       );


//     if (!review) {
//       review =
//         source.querySelector(
//           '[data-review-id]'
//         );
//     }


//     if (!review) {
//       review =
//         source.querySelector(
//           '.jdgm-review'
//         );
//     }


//     return review;
//   }


//   function initFeaturedJudgeMe() {
//     var wrapper =
//       document.querySelector(
//         '[data-mw-judgeme-review]'
//       );

//     var source =
//       document.querySelector(
//         '.mw-judgeme-source'
//       );


//     if (!wrapper || !source) {
//       return;
//     }


//     if (
//       wrapper.dataset.mwReady ===
//       'true'
//     ) {
//       return;
//     }


//     function tryRender() {
//       var reviewNode =
//         findRenderedReview();


//       if (!reviewNode) {
//         return false;
//       }


//       var review =
//         extractReview(
//           reviewNode
//         );


//       if (!review) {
//         return false;
//       }


//       var success =
//         renderCustomReview(
//           wrapper,
//           review
//         );


//       if (success) {
//         wrapper.dataset.mwReady =
//           'true';
//       }


//       return success;
//     }


//     /*
//       Judge.me may already be rendered
//       before this script executes.
//     */

//     if (tryRender()) {
//       return;
//     }


//     /*
//       Otherwise wait for Judge.me
//       to inject its review markup.
//     */

//     var observer =
//       new MutationObserver(
//         function () {

//           if (tryRender()) {
//             observer.disconnect();
//           }

//         }
//       );


//     observer.observe(
//       source,
//       {
//         childList: true,
//         subtree: true,
//         characterData: true
//       }
//     );


//     /*
//       Stop waiting after 10 seconds.
//     */

//     setTimeout(
//       function () {

//         observer.disconnect();


//         if (
//           wrapper.dataset.mwReady !==
//           'true'
//         ) {

//           console.warn(
//             'Judge.me review did not render inside hidden source.'
//           );


//           var loading =
//             wrapper.querySelector(
//               '.mw-judgeme-featured-review__loading'
//             );


//           if (loading) {
//             loading.style.display =
//               'none';
//           }


//           wrapper.style.display =
//             'none';
//         }

//       },
//       10000
//     );
//   }


//   if (
//     document.readyState ===
//     'loading'
//   ) {

//     document.addEventListener(
//       'DOMContentLoaded',
//       initFeaturedJudgeMe
//     );

//   } else {

//     initFeaturedJudgeMe();

//   }


//   document.addEventListener(
//     'shopify:section:load',
//     function () {

//       setTimeout(
//         initFeaturedJudgeMe,
//         300
//       );

//     }
//   );

// })();

(function () {
  'use strict';

  function cleanText(value) {
    return (value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }


  function getInitial(name) {
    return name
      ? name.trim().charAt(0).toUpperCase()
      : 'C';
  }


  function getRating(node) {
    var ratingNode =
      node.querySelector('[data-score]') ||
      node.querySelector('.jdgm-rev__rating');

    if (!ratingNode) {
      return 5;
    }

    var score =
      ratingNode.getAttribute('data-score');

    if (score) {
      return Number(score) || 5;
    }

    var label =
      ratingNode.getAttribute('aria-label') ||
      '';

    var match =
      label.match(/([0-5](?:\.\d+)?)/);

    return match
      ? Number(match[1])
      : 5;
  }


  function makeStars(rating) {
    rating = Math.round(
      Math.max(
        0,
        Math.min(
          5,
          Number(rating) || 0
        )
      )
    );

    var html = '';

    for (var i = 1; i <= 5; i++) {
      html +=
        i <= rating
          ? '★'
          : '☆';
    }

    return html;
  }


  function extractReview(node) {
    if (!node) return null;

    var nameNode =
      node.querySelector('.jdgm-rev__author') ||
      node.querySelector('.jdgm-reviewer-name') ||
      node.querySelector('[data-reviewer-name]');

    var titleNode =
      node.querySelector('.jdgm-rev__title') ||
      node.querySelector('[data-review-title]');

    var bodyNode =
      node.querySelector('.jdgm-rev__body') ||
      node.querySelector('.jdgm-text') ||
      node.querySelector('[data-review-body]');

    var verifiedNode =
      node.querySelector('.jdgm-rev__buyer-badge') ||
      node.querySelector('.jdgm-verified-badge') ||
      node.querySelector('[data-verified]');


    var name =
      nameNode
        ? cleanText(nameNode.textContent)
        : 'Customer';

    var title =
      titleNode
        ? cleanText(titleNode.textContent)
        : '';

    var body =
      bodyNode
        ? cleanText(bodyNode.textContent)
        : '';

    if (!body) {
      return null;
    }

    return {
      name: name,
      title: title,
      body: body,
      rating: getRating(node),
      verified: !!verifiedNode
    };
  }


  function getReviews(source) {
    var nodes =
      source.querySelectorAll(
        '.jdgm-rev, [data-review-id], .jdgm-review'
      );

    var reviews = [];
    var used = {};

    nodes.forEach(function (node) {
      var review =
        extractReview(node);

      if (!review) return;

      var key =
        review.name +
        '|' +
        review.title +
        '|' +
        review.body;

      if (used[key]) {
        return;
      }

      used[key] = true;

      reviews.push(review);
    });

    return reviews;
  }


  function createSlide(review) {
    var slide =
      document.createElement('div');

    slide.className =
      'mw-review-slide';

    var verifiedHTML =
      review.verified
        ? '<span class="mw-review-verified">✓</span>'
        : '';

    var titleHTML =
      review.title
        ? '<div class="mw-review-title"></div>'
        : '';

    slide.innerHTML =
      '<div class="mw-review-card">' +

        '<div class="mw-review-author-row">' +

          '<div class="mw-review-avatar">' +
            getInitial(review.name) +
          '</div>' +

          '<div class="mw-review-author-info">' +
            '<div class="mw-review-name"></div>' +
            verifiedHTML +
          '</div>' +

        '</div>' +

        '<div class="mw-review-inner">' +

          '<div class="mw-review-stars">' +
            makeStars(review.rating) +
          '</div>' +

          titleHTML +

          '<div class="mw-review-body"></div>' +

        '</div>' +

      '</div>';

    var name =
      slide.querySelector(
        '.mw-review-name'
      );

    if (name) {
      name.textContent =
        review.name;
    }

    var title =
      slide.querySelector(
        '.mw-review-title'
      );

    if (title) {
      title.textContent =
        review.title;
    }

    var body =
      slide.querySelector(
        '.mw-review-body'
      );

    if (body) {
      body.textContent =
        review.body;
    }

    return slide;
  }


  function buildCarousel(wrapper, reviews) {
    if (!wrapper || !reviews.length) {
      return;
    }

    wrapper.innerHTML = '';

    var carousel =
      document.createElement('div');

    carousel.className =
      'mw-review-carousel';


    var viewport =
      document.createElement('div');

    viewport.className =
      'mw-review-viewport';


    var track =
      document.createElement('div');

    track.className =
      'mw-review-track';


    reviews.forEach(function (review) {
      track.appendChild(
        createSlide(review)
      );
    });


    viewport.appendChild(track);
    carousel.appendChild(viewport);


    var prev = null;
    var next = null;


    if (reviews.length > 1) {

      prev =
        document.createElement(
          'button'
        );

      next =
        document.createElement(
          'button'
        );


      prev.type = 'button';
      next.type = 'button';


      prev.className =
        'mw-review-arrow mw-review-arrow--prev';

      next.className =
        'mw-review-arrow mw-review-arrow--next';


      prev.setAttribute(
        'aria-label',
        'Previous review'
      );

      next.setAttribute(
        'aria-label',
        'Next review'
      );


      prev.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true">' +
          '<path d="M15 18l-6-6 6-6"/>' +
        '</svg>';


      next.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true">' +
          '<path d="M9 6l6 6-6 6"/>' +
        '</svg>';


      carousel.appendChild(prev);
      carousel.appendChild(next);
    }


    wrapper.appendChild(carousel);


    var current = 0;


    function updateSlider(animate) {
      if (!animate) {
        track.style.transition =
          'none';
      }

      track.style.transform =
        'translate3d(-' +
        current * 100 +
        '%,0,0)';

      if (!animate) {
        track.offsetHeight;

        track.style.transition =
          '';
      }
    }


    function nextSlide() {
      current++;

      if (
        current >= reviews.length
      ) {
        current = 0;
      }

      updateSlider(true);
    }


    function prevSlide() {
      current--;

      if (current < 0) {
        current =
          reviews.length - 1;
      }

      updateSlider(true);
    }


    if (reviews.length > 1) {

      next.addEventListener(
        'click',
        nextSlide
      );

      prev.addEventListener(
        'click',
        prevSlide
      );


      /* MOBILE SWIPE */

      var startX = 0;
      var endX = 0;


      viewport.addEventListener(
        'touchstart',
        function (event) {
          startX =
            event.touches[0]
              .clientX;
        },
        {
          passive: true
        }
      );


      viewport.addEventListener(
        'touchend',
        function (event) {
          endX =
            event.changedTouches[0]
              .clientX;

          var diff =
            startX - endX;

          if (
            Math.abs(diff) < 40
          ) {
            return;
          }

          if (diff > 0) {
            nextSlide();
          } else {
            prevSlide();
          }
        },
        {
          passive: true
        }
      );
    }


    updateSlider(false);

    wrapper.classList.add(
      'is-loaded'
    );
  }


  function initJudgeMeCarousel() {
    var desktopWrapper =
      document.querySelector(
        '[data-mw-judgeme-review]'
      );

    var mobileWrapper =
      document.querySelector(
        '[data-mw-judgeme-review-mobile]'
      );

    var source =
      document.querySelector(
        '.mw-judgeme-source'
      );


    if (
      !desktopWrapper ||
      !source
    ) {
      return;
    }


    if (
      desktopWrapper.dataset
        .carouselReady === 'true'
    ) {
      return;
    }


    function tryBuild() {
      var reviews =
        getReviews(source);

      if (!reviews.length) {
        return false;
      }


      desktopWrapper.dataset
        .carouselReady = 'true';


      /* DESKTOP */

      buildCarousel(
        desktopWrapper,
        reviews
      );


      /* MOBILE */

      if (mobileWrapper) {

        buildCarousel(
          mobileWrapper,
          reviews
        );

      }


      return true;
    }


    if (tryBuild()) {
      return;
    }


    var observer =
      new MutationObserver(
        function () {

          if (tryBuild()) {
            observer.disconnect();
          }

        }
      );


    observer.observe(
      source,
      {
        childList: true,
        subtree: true,
        characterData: true
      }
    );


    setTimeout(
      function () {

        observer.disconnect();


        if (
          desktopWrapper.dataset
            .carouselReady !== 'true'
        ) {

          desktopWrapper.style.display =
            'none';


          if (mobileWrapper) {
            mobileWrapper.style.display =
              'none';
          }

        }

      },
      10000
    );
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initJudgeMeCarousel
    );

  } else {

    initJudgeMeCarousel();

  }


  document.addEventListener(
    'shopify:section:load',
    function () {

      setTimeout(
        initJudgeMeCarousel,
        300
      );

    }
  );

})();